document.addEventListener("DOMContentLoaded", function () {
  document.documentElement.classList.add("syxen-ready");
});

document.addEventListener("click", function (event) {
  const cartButton = event.target.closest("[data-cart-qty]");
  if (cartButton) {
    const input = document.getElementById(cartButton.getAttribute("data-cart-target"));
    if (!input) return;

    const action = cartButton.getAttribute("data-cart-qty");
    const current = parseInt(input.value || "0", 10);

    if (action === "minus") {
      input.value = Math.max(current - 1, 0);
    }

    if (action === "plus") {
      input.value = current + 1;
    }

    const form = cartButton.closest("[data-cart-form]");
    if (form) {
      form.submit();
    }
    return;
  }

  const productButton = event.target.closest("[data-product-qty]");
  if (productButton) {
    const input = document.getElementById(productButton.getAttribute("data-product-target"));
    if (!input) return;

    const action = productButton.getAttribute("data-product-qty");
    const current = parseInt(input.value || "1", 10);

    if (action === "minus") {
      input.value = Math.max(current - 1, 1);
    }

    if (action === "plus") {
      input.value = current + 1;
    }
  }
});
